<template>
    <div class="user-profile-collection">
      
      <!-- //Loading.. -->
      <div class="spinner-border  spinner-border-sm text-primary" role="status" v-if="attemptsGetClients == 0">        
      </div>

      <template v-else> 

        <template v-if="clients.length > 0">
          
          <div v-if="forRanking">
            <ol class="mr-5">
              <li v-for="(client, index) in clients" :key="client.id" class="text-truncate">
                <span
                  class="text-truncate d-inline-block"
                  style="max-width: 200px;"
                  :title="client.name"
                >
                  <strong>{{ client.name }}</strong> 
                </span>
              </li>
            </ol>
          </div>

          <div 
            v-else
            v-for="(client, index) in clients" 
            :key="client.id" 
            class="user-photo"
            :style="{ 
              backgroundImage: `url(${client.photo})`,
              left: `${index * 5}px` 
            }"
            :title="client.name"
          ></div>
          
        </template>

        <template v-else>

          <span v-if="!forRanking">-</span>
        
        </template>

      </template>
      
    </div>
  </template>
  
  <script>

  import { usersService } from "@/_services";
  import LoadingSpinner from "@/components/LoadingSpinner.vue";


  export default {
    name: "ImageSetClients",
    components: {
      LoadingSpinner,
    },
    props: {
      user_id: {
        type: String,
        required: true,
      },
    },

    created() {
      if(this.$route.fullPath == '/allbdr/5') this.forRanking = true;
      this.getClientsOfBooker(this.user_id);
    },

    data() {
      return {
        clients: [],
        attemptsGetClients: 0,
        forRanking: false,
      };
    },

    methods: {
      getClientsOfBooker(user_id) {
        usersService.getClientsOfBooker(user_id)
          .then((res) => {
            if (res !== undefined) {              
              this.clients = res.result;
              this.clients.forEach(client => {
                if(client.has_avatar == 1){
                  let base64 = '';
                  base64 = btoa(`usr-${client.user_id}`);
                  client.photo = process.env.VUE_APP_ROOT_API + '/redirect/image/' + base64;
                }else{
                  client.photo = require('@/assets/images/emptyperson.png');
                }
              });
            }
            this.attemptsGetClients++;
          })
          .catch((err) => {
            console.log(err);
          });
      },
    },

  };

  
  </script>
  
  <style scoped>
  .user-profile-collection {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
  }
  
  .user-photo {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background-size: cover;
    background-position: center;
    border: 2px solid #fff; 
    transition: transform 0.2s ease-in-out;
  }
  
  .user-photo:hover {
    transform: scale(1.1); 
  }
  </style>
  